import { CALL_API, Schemas } from '../../common/middleware/api';

export const ENROLMENT_FETCH_REQUEST = 'ENROLMENT_GET_REQUEST';
export const ENROLMENT_FETCH_SUCCESS = 'ENROLMENT_GET_SUCCESS';
export const ENROLMENT_FETCH_FAILURE = 'ENROLMENT_GET_FAILURE';

export const ENROLMENTS_REQUEST = 'ENROLMENTS_REQUEST';
export const ENROLMENTS_SUCCESS = 'ENROLMENTS_SUCCESS';
export const ENROLMENTS_FAILURE = 'ENROLMENTS_FAILURE';

export const loadEnrolments = (options) => ({
	[CALL_API]: {
		types: [ENROLMENTS_REQUEST, ENROLMENTS_SUCCESS, ENROLMENTS_FAILURE],
		endpoint: 'api/enrolments',
		request: options,
		schema: Schemas.ENROLMENT_ARRAY
	}
});

export const fetchEnrolment = (id) => ({
	[CALL_API]: {
		types: [ENROLMENT_FETCH_REQUEST, ENROLMENT_FETCH_SUCCESS, ENROLMENT_FETCH_FAILURE],
		endpoint: `api/enrolments/${id}`,
		schema: Schemas.ENROLMENT
	}
});